import { useEffect, useState } from "react";
import QRCode from "qrcode";
import type { SlideProps } from "@/engine/app/offsite-config";
import { useOffsiteConfig } from "@/engine/app/offsite-context";

export function Slide19Danke(_: SlideProps) {
  // Die Ergebnisseite steht in der Offsite-Konfiguration — die Folie kennt
  // den Pfad nicht selbst, sonst stünde er an zwei Stellen.
  const { ergebnisse } = useOffsiteConfig();
  const [qrSvg, setQrSvg] = useState<string | null>(null);

  useEffect(() => {
    if (!ergebnisse) return;
    QRCode.toString(ergebnisse.url, {
      type: "svg",
      // "M" statt "H": die URL ist lang, und jedes Korrekturniveau mehr
      // verdichtet das Muster weiter — vom Beamer wird es sonst unlesbar.
      errorCorrectionLevel: "M",
      margin: 1,
      color: { dark: "#001E62", light: "#FFFFFF" },
    })
      .then(setQrSvg)
      .catch(() => setQrSvg(null));
  }, [ergebnisse]);

  return (
    <div className="deck-root dark slide-manifesto" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 420,
          height: 420,
          top: "-120px",
          right: "-100px",
          background: "var(--svo-blau)",
          opacity: 0.3,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 320,
          height: 320,
          bottom: "-100px",
          left: "10%",
          background: "var(--svo-gruen)",
          opacity: 0.12,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Danke</div>
        <h1
          className="deck-title rise rise-2"
          style={{
            fontSize: "clamp(5rem, 13vw, 11rem)",
            fontWeight: 200,
            color: "var(--svo-blau)",
            lineHeight: 0.95,
            letterSpacing: "-0.04em",
          }}
        >
          Danke!
        </h1>
        <p className="deck-sub rise rise-3" style={{ fontStyle: "italic" }}>
          Wir gestalten die SVO bis 2030 durchgehend digital — und das klappt
          nur mit eurer Hilfe.
        </p>
      </header>

      <div
        className="deck-lead"
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          gap: "2rem",
          flexWrap: "wrap",
        }}
      >
        <div>
          <div className="lead-body rise rise-4" style={{ color: "var(--svo-weiss)", fontWeight: 500 }}>
            Viktor Lüders
          </div>
          <div className="lead-body rise rise-5" style={{ color: "rgba(255,255,255,0.7)" }}>
            IT Requirements Manager · SVO
          </div>
        </div>

        {/* Alles von heute zum Nachlesen — der Code ist der einzige Zugang,
            die Seite liegt hinter einem nicht erratbaren Pfad. */}
        {ergebnisse && (
          <div
            className="rise rise-5"
            style={{ display: "flex", alignItems: "center", gap: "1rem" }}
          >
            <div
              aria-hidden="true"
              style={{
                width: 240,
                height: 240,
                background: "#fff",
                borderRadius: 12,
                padding: 10,
                display: "grid",
                placeItems: "center",
              }}
            >
              {qrSvg ? (
                <span
                  style={{ display: "block", width: "100%", height: "100%" }}
                  dangerouslySetInnerHTML={{ __html: qrSvg }}
                />
              ) : null}
            </div>
            <div style={{ maxWidth: "15rem" }}>
              <div
                style={{
                  fontSize: ".72rem",
                  letterSpacing: ".12em",
                  textTransform: "uppercase",
                  fontWeight: 600,
                  color: "var(--svo-blau)",
                  marginBottom: 6,
                }}
              >
                Alles von heute
              </div>
              <div
                style={{
                  color: "var(--svo-weiss)",
                  fontSize: "1rem",
                  lineHeight: 1.35,
                  fontWeight: 500,
                }}
              >
                Eure Prototypen, die Auswertung und diese Folien — scannen und
                in Ruhe nachlesen.
              </div>
            </div>
          </div>
        )}
      </div>

      <footer className="deck-foot">
        <span>SVO · Celle · Uelzen</span>
      </footer>
    </div>
  );
}
